var _defs, _g, _ellipse, _g2, _g3, _g4, _g5, _g6, _path, _g7, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintainHeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484.7424,
    height: 746.76984,
    viewBox: "0 0 484.7424 746.76984",
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    id: "svg440",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Set-up-heating",
    transform: "matrix(0.829192,0,0,1.09268,-642.81771,-2006.1353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g350"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.956709,0,0,0.673311,-115.865,826.292)",
    id: "g280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g278"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1463.1,1693.76 c 12.36,7.4 23.8,16.69 33.97,27.65 29.07,31.35 45.4,73.86 45.4,118.19 v 481.67 c 0,60.68 -34.85,112.59 -84.16,133.68 3.14,3.27 4.79,6.67 4.79,10.16 0,27.32 -101.33,49.5 -226.15,49.5 -124.82,0 -226.16,-22.18 -226.16,-49.5 0,-3.49 1.65,-6.89 4.8,-10.16 -49.317,-21.09 -84.169,-73 -84.169,-133.68 V 1839.6 c 0,-44.33 16.332,-86.84 45.402,-118.19 10.169,-10.96 21.605,-20.25 33.967,-27.65 v -94.98 h 452.31 z m -59.07,736.66 c -31.83,6.93 -103.18,20.71 -167.08,20.71 -63.91,0 -135.26,-13.78 -167.09,-20.71 -6.04,-15.59 -17.7,-28.11 -32.57,-34.47 -27.54,-11.78 -47.001,-40.78 -47.001,-74.68 0,-135.64 0,-338.89 0,-481.67 0,-27.49 10.131,-53.86 28.161,-73.3 6.26,-6.76 13.3,-12.48 20.91,-17.04 18.7,-11.19 30.3,-32.44 30.3,-55.5 v -31.5 c 0,0 224.83,0 334.58,0 0,0 0,31.5 0,31.5 0,23.06 11.59,44.31 30.29,55.5 7.61,4.56 14.65,10.28 20.91,17.04 18.03,19.44 28.16,45.81 28.16,73.3 v 481.67 c 0,33.9 -19.45,62.9 -47,74.68 -14.87,6.36 -26.53,18.88 -32.57,34.47 z",
    id: "path276"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35052,0,0,0.915179,-243.95,1150.29)",
    id: "g286"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.09399,
    cy: 1434.61,
    rx: 111.507,
    ry: 11.436,
    style: {
      fill: "#ffffff"
    },
    id: "ellipse282"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.09399,
    cy: 1434.61,
    rx: 111.507,
    ry: 11.436,
    id: "ellipse284"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g292"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 717.138,867.042 23.954,-0.845 1.907,16.939 c 0,0 1.914,1.901 -2.26,10.804 -21.133,11.573 -70.759,58.86 -70.759,127.79 0,68.94 -16.626,107.4 -22.655,109.92 -0.017,-48.15 -0.048,-130.7 -0.048,-130.7 0,0 -9.572,-54.002 69.03,-107.841 1.832,-57.445 0.831,-26.067 0.831,-26.067 z",
    style: {
      fill: "#ffffff"
    },
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 717.138,867.042 23.954,-0.845 1.907,16.939 c 0,0 1.914,1.901 -2.26,10.804 -21.133,11.573 -70.759,58.86 -70.759,127.79 0,68.94 -16.626,107.4 -22.655,109.92 -0.017,-48.15 -0.048,-130.7 -0.048,-130.7 0,0 -9.572,-54.002 69.03,-107.841 1.832,-57.445 0.831,-26.067 0.831,-26.067 z m 1.617,1.611 20.854,-0.736 c 0,0 1.734,15.405 1.734,15.405 l 1.656,1.48 -1.347,-0.698 c 0,0 0.193,0.84 0.035,1.953 -0.208,1.47 -0.825,3.609 -2.232,6.689 -21.642,12.154 -71.142,59.773 -71.142,128.984 0,47.94 -8.062,81.05 -14.972,97.45 -1.552,3.69 -3.035,6.51 -4.351,8.43 l -0.046,-126.66 c 0,-0.1 -0.009,-0.19 -0.026,-0.29 0,0 -9.179,-53.086 68.331,-106.176 0.438,-0.3 0.707,-0.791 0.724,-1.322 z",
    style: {
      fill: "#ffffff"
    },
    id: "path290"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g296"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1059.42,835.349 v 60.593 c 0,0 57.95,39.844 60.97,102.017 3.03,62.171 0.34,365.221 0.34,365.221 0,0 5.71,43.03 -65.42,81.67 -0.39,5.06 -0.56,7.3 -0.56,7.3",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path294"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1088.29,994.081 V 1362.43",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path298"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g304"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 654.195,1362.43 c 0,0 -4.66,51.28 54.196,80.45 12.397,-6.07 13.99,3.05 13.99,3.05 l -1.827,9.84 c 0,0 176.336,65.67 334.196,-3.62",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path302"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g308"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 681.734,1097.4 2.227,265.03 c 0,0 0,37.27 31.738,49.01",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path306"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,17.0894,1158.34)",
    id: "g312"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.005,
    y: 754.17499,
    width: 418.38901,
    height: 54.116001,
    id: "rect310"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06431,0,0,0.23221,141.234,1660.85)",
    id: "g316"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.005,
    y: 754.17499,
    width: 418.38901,
    height: 54.116001,
    id: "rect314"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 689.382,768.882 -0.272,40.678 16.642,-1.085 c 0,0 6.952,-30.372 114.612,-34.711 107.661,-4.339 -130.982,-4.882 -130.982,-4.882 z",
    style: {
      fill: "#ffffff"
    },
    id: "path318"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26458,0,0,1.32278,-50.3321,805.919)",
    id: "g324"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 694.35602,
    y: 840.68103,
    width: 389.12399,
    height: 12.078,
    id: "rect322"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26458,0,0,0.915179,-50.3321,1126.78)",
    id: "g328"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 694.35602,
    y: 840.68103,
    width: 389.12399,
    height: 12.078,
    id: "rect326"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.43432,0,0,0.527926,-152.675,1467.89)",
    id: "g332"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 691.99103,
    y: 814.841,
    width: 326.884,
    height: 12.078,
    style: {
      fill: "#ffffff"
    },
    id: "rect330"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.43432,0,0,0.768764,-152.675,1295.89)",
    id: "g336"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 691.99103,
    y: 814.841,
    width: 326.884,
    height: 12.078,
    style: {
      fill: "#ffffff"
    },
    id: "rect334"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18617,0,0,0.915179,14.1048,1150.43)",
    id: "g340"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 711.49402,
    y: 755.94702,
    width: 321.77802,
    height: 9.7729998,
    style: {
      fill: "#ffffff"
    },
    id: "rect338"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1042.6801,
    y: 755.94702,
    width: 26.976,
    height: 9.7729998,
    style: {
      fill: "#ffffff"
    },
    id: "rect342"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g348"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1090.19,768.882 c 0,0 -9.56,4.556 -7.29,10.433 2.28,5.877 -3.84,27.578 -29.38,30.245 -25.54,2.667 40.43,1.961 40.43,1.961 l -3.76,-42.639",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path346"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer1",
    transform: "matrix(0.477198,0,0,0.362127,476.176,1492.79)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09979,0,0,1.09979,307.054,955.528)",
    id: "g354"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 829.25,1461.08 C 138.205,1186.43 859.587,902.998 817.51,445.751 c 283.86,164.421 154.427,366.862 154.427,366.862 0,0 94.813,-102.698 127.133,-77.09 -90.66,231.647 317.7,531.807 -201.04,729.107 364.57,-232.37 -80.902,-335 -15.623,-549.81 -114.8,24.67 -154.977,317.45 -114.156,358.28 -23.047,4.43 -59.476,-41.97 -59.931,-73.04 -36.758,100.22 -13.784,177.96 120.93,261.02 z",
    style: {
      stroke: "#000000",
      strokeWidth: "7.09px"
    },
    id: "path352"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g358"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 756.144,1449.45 c 0,0 -229.551,-78.84 -218.318,-302.27 32.662,171.1 157.941,274.15 218.318,302.27 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: "2.53px"
    },
    id: "path356"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g362"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 957.013,1478.48 c 0,0 205.527,-79.26 150.837,-272.7 -34.34,-121.43 -13.07,-135.77 10.74,-232.183 0.58,-2.387 4.14,-2.507 6.24,-3.557 -23.22,212.46 221.75,286.62 -167.817,508.44 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: "2.53px"
    },
    id: "path360"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g366"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 618.346,1292.24 c 0,0 35.118,104.64 162.711,168.56 -61.65,-46.5 -89.086,-107.39 -94.563,-158.81 -4.453,47.35 -3.375,60.57 -68.148,-9.75 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: "2.53px"
    },
    id: "path364"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.895,1072.17)",
    id: "g370"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1128.08,696.722 c 0,0 -68.1,66.822 -45.54,116.194 22.55,49.372 35.75,135.347 38.73,135.773 2.98,0.425 1.27,-88.955 -6.39,-116.62 -7.66,-27.665 -17.45,-94.062 13.2,-135.347 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: "2.53px"
    },
    id: "path368"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g374"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1132.33,698.425 c 0,0 -63.97,41.135 -79.9,149.428 -7.03,-56.801 -5.34,-66.436 -5.34,-66.436 0,0 5.4,-67.47 85.24,-82.992 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: "2.53px"
    },
    id: "path372"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g378"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 834.394,387.694 c 0,0 11.581,27.348 15.711,34.551 184.005,320.869 98.249,355.727 79.753,425.608 14.57,-27.296 88.832,-97.903 77.022,-195.376 C 993.97,545.888 946.821,449.623 883.152,421.49 c -0.66,-0.291 -1.309,-0.589 -1.948,-0.891 -25.575,-2.604 -19.459,-13.679 -46.81,-32.905 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: "2.53px"
    },
    id: "path376"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 834.394,387.694 c 0,0 81.705,107.877 91.039,122.742 -4.161,-26.274 -46.325,-97.835 -46.325,-97.835 z",
    style: {
      stroke: "#000000",
      strokeWidth: "2.53px"
    },
    id: "path380"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g388"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 730.149,741.419 c 0,0 125.318,-161.94 155.646,-117.306 30.328,44.633 20.198,-117.307 -17.739,-157.935 -37.936,-40.628 -27.467,-17.113 -27.467,-17.113 -26.763,171.569 -70.48,218.106 -110.44,292.354 z",
    id: "path384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 730.149,741.419 c 0,0 125.318,-161.94 155.646,-117.306 30.328,44.633 20.198,-117.307 -17.739,-157.935 -37.936,-40.628 -27.467,-17.113 -27.467,-17.113 -26.763,171.569 -70.48,218.106 -110.44,292.354 z M 855.254,481.814 c 6.622,8.22 11.727,21.236 16.055,35.74 7.882,26.418 12.188,57.807 12.341,80.654 -6.111,-2.039 -12.963,-2.379 -20.469,-1.119 -10.338,1.736 -22.665,7.384 -35.619,16.24 -3.625,2.478 -7.331,5.222 -11.087,8.178 l -0.002,0.001 c 14.446,-35.293 27.745,-79.073 38.781,-139.694 z",
    id: "path386"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g394"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 712.41,1123.9 c 0,0 5.477,109.53 38.336,142.39 -11.949,-77.67 -4.978,-141.27 31.864,-287.271 -41.821,126.331 -53.77,228.021 -70.2,144.881 z",
    style: {
      fill: "#ffffff"
    },
    id: "path390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 712.41,1123.9 c 0,0 5.477,109.53 38.336,142.39 -11.949,-77.67 -4.978,-141.27 31.864,-287.271 -41.821,126.331 -53.77,228.021 -70.2,144.881 z",
    style: {
      fill: "#ffffff"
    },
    id: "path392"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1005.77,1183.28 c 107.96,158.32 8.9,234.93 -93.84,304.99 131,-136.61 133.47,-206.79 93.84,-304.99 z",
    style: {
      fill: "#ffffff"
    },
    id: "path396"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 1005.77,1183.28 c 53.98,79.16 56.2,137.89 32.09,185.59 -24.11,47.7 -74.559,84.37 -125.93,119.4 131,-136.61 133.47,-206.79 93.84,-304.99 z",
    id: "path398"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.125,1074.39)",
    id: "g406"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 859.587,1488.27 c 0,0 -102.578,-47.21 -63.683,-118.14 16.09,44.63 27.837,39.66 44.235,46.52 28.6,-22.88 28.763,-47.06 -10.895,-123.66 -18.304,-3.81 112.531,59.6 82.686,94.68 -29.845,35.08 8.07,40.1 31.167,13.73 -4.793,50.33 -32.03,79.28 -83.51,86.87 z",
    id: "path402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 830.806,1296.04 c -3.573,-2.51 -4.537,-3.67 -1.562,-3.05 l 1.562,3.05 c 18.412,13 106.12,62.25 81.124,91.63 -29.845,35.08 8.07,40.1 31.167,13.73 -4.793,50.33 -32.03,79.28 -83.51,86.87 0,0 -102.578,-47.21 -63.683,-118.14 16.09,44.63 27.837,39.66 44.235,46.52 28.217,-22.57 28.753,-46.42 -9.333,-120.61 z m 45.393,56.06 c 0.953,3.36 1.72,6.56 2.32,9.59 3.166,16.02 2.089,28.69 -1.961,39.58 -4.328,11.63 -12.207,21.51 -23.98,30.93 -5.689,4.55 -13.408,5.63 -20.128,2.82 -5.677,-2.38 -10.808,-3.76 -15.744,-5.71 3.103,4.49 6.73,8.62 10.496,12.37 12.855,12.78 27.823,21.71 35.533,25.86 h 0.003 c 17.748,-3.43 31.725,-9.99 41.719,-20.44 2.652,-2.77 5.006,-5.8 7.074,-9.09 -9.435,-0.1 -16.957,-3.53 -22.041,-8.46 -8.468,-8.22 -15.46,-27.64 6.766,-54.17 -0.151,-0.48 -0.367,-1.12 -0.568,-1.55 -1.01,-2.16 -2.496,-4.33 -4.245,-6.54 -4.046,-5.11 -9.375,-10.22 -15.244,-15.19 z",
    id: "path404"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(396.153,1118.76)",
    id: "g412"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 544.026,921.746 c 0,0 90.345,-120.461 70.916,-178.749 -19.429,-58.287 0,-99.089 34.973,-107.832 34.972,-8.743 -7.772,187.492 -105.889,286.581 z",
    style: {
      fill: "#ffffff"
    },
    id: "path408"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 544.026,921.746 c 0,0 90.345,-120.461 70.916,-178.749 -19.429,-58.287 0,-99.089 34.973,-107.832 34.972,-8.743 -7.772,187.492 -105.889,286.581 z m 97.688,-260.87 c -13.916,11.218 -18.566,34.066 -11.437,63.483 5.646,-19.667 9.331,-37.541 10.941,-52.069 0.418,-3.774 0.53,-7.787 0.496,-11.414 z",
    id: "path410"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g418"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 901.139,911.063 c 0,0 -54.3,64.702 -32.385,112.257 25.854,56.11 76.472,98.4 76.472,98.4 0,0 -18.768,-20.32 -36.253,-49.65 -15.425,-25.87 -29.851,-58.74 -29.516,-90.843 0.713,-68.495 21.682,-70.164 21.682,-70.164 z",
    style: {
      fill: "#ffffff"
    },
    id: "path414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 884.821,934.539 c -13.914,23.152 -29.667,59.269 -16.067,88.781 25.854,56.11 76.472,98.4 76.472,98.4 0,0 -18.768,-20.32 -36.253,-49.65 -15.425,-25.87 -29.851,-58.74 -29.516,-90.843 0.223,-21.446 2.432,-36.34 5.364,-46.688 8.502,-14.162 16.318,-23.476 16.318,-23.476 0,0 -9.894,0.788 -16.318,23.476 z",
    style: {
      fill: "#030000"
    },
    id: "path416"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.681,1031.5)",
    id: "g424"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 1157.31,1121.72 c 0,0 -24.32,34.6 -16.84,65.93 7.48,31.33 3.74,110.82 6.08,108.02 33.2,-64.06 35.54,-67.8 29.93,-101 -5.61,-33.2 -19.17,-72.95 -19.17,-72.95 z",
    id: "path420"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 1157.31,1121.72 c 0,0 -24.32,34.6 -16.84,65.93 7.48,31.33 3.74,110.82 6.08,108.02 33.2,-64.06 35.54,-67.8 29.93,-101 -5.61,-33.2 -19.17,-72.95 -19.17,-72.95 z",
    style: {
      fill: "#030000"
    },
    id: "path422"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g430"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 794.59,1295.74 c 0,0 -89.189,-1.21 -88.255,-47.61 0.934,-46.4 -42.804,113.47 79.85,191.45 -33.311,-53.23 -72.379,-118.16 8.405,-143.84 z",
    style: {
      fill: "#ffffff"
    },
    id: "path426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 794.59,1295.74 c 0,0 -89.189,-1.21 -88.255,-47.61 0.934,-46.4 -42.804,113.47 79.85,191.45 -33.311,-53.23 -72.379,-118.16 8.405,-143.84 z m -70.283,5.36 c 1.26,8.3 3.049,17.18 5.568,26.32 0.776,-2.57 1.719,-5.09 2.832,-7.55 1.965,-4.34 4.475,-8.59 7.626,-12.67 v 0 c -3.672,-1.12 -7.313,-2.39 -10.842,-3.82 -1.762,-0.72 -3.492,-1.48 -5.184,-2.28 z",
    style: {
      fill: "#030000"
    },
    id: "path428"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.639,1070.46)",
    id: "g436"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1030.12,483.969 c 0,0 66.93,139.309 30.35,183.67 -36.58,44.361 82.49,-50.587 87.16,-71.6 4.67,-21.013 -10.11,4.67 -36.57,6.226 -26.46,1.557 -25.69,-102.731 -80.94,-118.296 z",
    style: {
      fill: "#ffffff"
    },
    id: "path432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1030.12,483.969 c 0,0 66.93,139.309 30.35,183.67 -36.58,44.361 82.49,-50.587 87.16,-71.6 4.67,-21.013 -10.11,4.67 -36.57,6.226 -26.46,1.557 -25.69,-102.731 -80.94,-118.296 z m 60.58,130.743 c 0.36,4.607 0.52,9.122 0.49,13.521 2.99,-2.601 5.96,-5.241 8.86,-7.883 -3.27,-1.231 -6.4,-3.098 -9.35,-5.638 z",
    style: {
      fill: "#030000"
    },
    id: "path434"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintainHeat);
export default __webpack_public_path__ + "static/media/maintain-heat.a09016bf11016a50359db80e33c3e131.svg";
export { ForwardRef as ReactComponent };